'use client'
import { SetupModule } from '@repo/hmrc-itsa/SetupModule'

const HmrcItsaSetup = () => {
  return <SetupModule />
}

export default HmrcItsaSetup
